import axios from 'axios';
import { encryptPayload } from '../utilidades/encryption';
const apiClientEncrypt = axios.create({
    headers: { 'Content-Type': 'application/json' }
});

apiClientEncrypt.interceptors.request.use(config => {
  if (config.method === 'post' || config.method === 'put') {
    if (config.data) {
      config.data = encryptPayload(config.data);
      console.log(config);
    }
  }
  return config;
});

export default apiClientEncrypt;
